exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-deeptmhmm-index-tsx": () => import("./../../../src/pages/deeptmhmm/index.tsx" /* webpackChunkName: "component---src-pages-deeptmhmm-index-tsx" */),
  "component---src-pages-deeptmhmm-terms-tsx": () => import("./../../../src/pages/deeptmhmm/terms.tsx" /* webpackChunkName: "component---src-pages-deeptmhmm-terms-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

